// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__JI3jx","col":"styles_col__3pWDw"};